import React, { useState } from 'react';
import styles from './Header.module.css';
import logo from '../Assets/logocozimax.png';
import aviso from '../Assets/topo4.jpg';
import { QRCodeCanvas } from 'qrcode.react';
import api from '../api';
import { Alerta } from '../functions';

export default function Header() {
    const [token, setToken] = useState('');
    const [cnpj, setCnpj] = useState('');
    const [error, setError] = useState('');
    const [qrData, setQrData] = useState(`https://wa.me/5517981030058`);

    // Função de máscara de CNPJ
    const formatCnpj = (value) => {
        value = value.replace(/\D/g, ''); // Remove tudo que não é número
        if (value.length > 14) value = value.slice(0, 14);
        value = value.replace(/^(\d{2})(\d)/, '$1.$2');
        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
        value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
        value = value.replace(/(\d{4})(\d)/, '$1-$2');
        return value;
    };

    // Função de validação de CNPJ
    const validarCnpj = (cnpj) => {
        cnpj = cnpj.replace(/[^\d]+/g, '');
        if (cnpj === '' || cnpj.length !== 14) return false;
        if (/^(\d)\1+$/.test(cnpj)) return false;

        let tamanho = cnpj.length - 2;
        let numeros = cnpj.substring(0, tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) pos = 9;
        }

        let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado !== parseInt(digitos.charAt(0))) return false;

        tamanho += 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) pos = 9;
        }

        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        return resultado === parseInt(digitos.charAt(1));
    };

     async function GetBoleto() {
        await api.get(`boletos/geraboletolink/?cgccli=${cnpj}&token=${token}`, { responseType: 'blob' })
            .then((response) => {
                if (!response.data.msg) {
                    
                        let blob = new Blob([response.data], {
                            type: 'application/pdf'
                        });
                        let url = window.URL.createObjectURL(blob)
                        window.open(url);

                        setCnpj('');
                        setToken('');
                    
                } else {
                   setCnpj('');
                   setToken('');
                   Alerta('Erro', response.data.msg, 'error');  
                }
            }).catch((erro) => {
                setCnpj('');
                setToken('');
                Alerta('Erro', erro, 'error');
            })
    }

    const handleCnpjChange = (e) => {
        setCnpj(formatCnpj(e.target.value));
    };

    const handleSubmit = (e) => {
        setError('');
        e.preventDefault();
        if (!validarCnpj(cnpj)) {
            setError('CNPJ inválido.');
            return;
        }
        setError('');
        GetBoleto();
    };

    return (

        <div className={styles.page}>
            <header className={styles.header}>
                <img src={aviso} alt="Aviso"
                        style={{
                            width: "80%",
                            height: "120px",
                            objectFit: "contain",
                            borderRadius: "3px",
                            


                        }}

                    />
                <div className={styles.container}>
                    
                    

                    <h2>Gerador de Boletos</h2>

                    <form onSubmit={handleSubmit} className={styles.form}>
                        <div className={styles.inputGroup}>
                            <div className={styles.field}>
                                <label htmlFor="token">Código de Acesso</label>
                                <input
                                    type="text"
                                    id="token"
                                    value={token}
                                    onChange={(e) => setToken(e.target.value)}
                                    placeholder="Digite o código de acesso"
                                    required
                                />
                            </div>

                            <div className={styles.field}>
                                <label htmlFor="cnpj">CNPJ</label>
                                <input
                                    type="text"
                                    id="cnpj"
                                    value={cnpj}
                                    onChange={handleCnpjChange}
                                    placeholder="00.000.000/0000-00"
                                    maxLength={18}
                                    required
                                />
                            </div>
                        </div>

                        {error && <p className={styles.error}>{error}</p>}

                        <button type="submit" className={styles.button}>Gerar Boleto</button>
                    </form>
                </div>
            </header>

            {/* Se houver dados, exibe o QR Code */}
            {qrData && (
                <div className={styles.qrContainer}>
                    <h3>Solicite seus boletos direto pelo whatsApp !</h3>
                    <QRCodeCanvas
                        value={qrData}
                        size={200}
                        bgColor="#ffffff"
                        fgColor="#000000"
                        level="M"
                        includeMargin
                    />
                </div>
            )}

            <p>Todos os diretos reservados - Cozimax 2025</p>
        </div>

    );
}
